import { render, staticRenderFns } from "./BuildingsList.vue?vue&type=template&id=1edc080c&scoped=true"
import script from "./BuildingsList.vue?vue&type=script&lang=js"
export * from "./BuildingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc080c",
  null
  
)

export default component.exports